import React from 'react';
import { Button, Tooltip, Tag, Switch ,Radio} from 'antd';

import CustomTable from '../../components/CustomTable';

export default function ResultList(props) {

    function onChange(id, value) {
        
        const form = {
            id: id,
            valor: value
        }
        props.onSave(form);
      }

    return (
        <CustomTable
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                // {
                //     title: 'Parametro',
                //     dataIndex: 'nombreParametro',
                //     key: 'nombreParametro',
                //     sorter: true
                // },
                {
                    title: 'Pregunta',
                    dataIndex: 'pregunta',
                    key: 'pregunta',
                    sorter: true
                },
                // {
                //     title: 'Valor',
                //     dataIndex: 'valor',
                //     key: 'valor',
                //     sorter: true
                // },
                {
                    title: 'Seleccione',
                    width: "450px",
                    key: 'changeValue',
                    align: 'center',
                    render: (value, row) => (
                    
                     row.abreviatura === "VRT" ?
                     (
                        <div>
                            <Radio.Group 
                            onChange={
                                (option) => {
                                    onChange(row.id, option.target.value)
                                }
                            } 
                            defaultValue={row.valor}>
                                <Radio value={"1"}>A4</Radio>
                                <Radio value={"2"}>Ticket (80 mm)</Radio>
                                <Radio value={"3"}>Ticket (50 mm)</Radio>
                            </Radio.Group>
                        </div>

                     ):
                     (
                        <div>
                            <Radio.Group 
                            onChange={
                                (option) => {
                                    onChange(row.id, option.target.value)
                                }
                            } 
                            defaultValue={row.valor}>
                            <Radio value={"1"}>SI</Radio>
                            <Radio value={"0"}>NO</Radio>
                        </Radio.Group>
                        </div>
                     )
                    )
                },
                
            ]}
        />
    );
}